import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'shop/goods',
  urlRoot: 'shop/goods',

  state: {
    total: 0,
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total,
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  },

  mutations: {
    updateComplete(state) {
      state.isUpdating = false
    },
  },

  actions: {
    sortFiles({ commit }, hashes) {
      // TODO: Ensure server logic
      commit('updateStart')
      return http.post('/files/sort-ref', { hashes }).finally(() => {
        commit('updateComplete')
      })
    },

    removeFile({ commit }, hash) {
      // TODO: Ensure server logic
      commit('updateStart')
      return http.delete(`/shop/goods/files/${hash}`).finally(() => {
        commit('updateComplete')
      })
    },
  },
})

export default withDataFilter(store)
